import { Injectable } from '@angular/core';
import { Location } from '../../models/location.model';

@Injectable()
export class CachedDataService {
    public locations: Location[];

    //
    //constructor
    //
    constructor() {
    }
}